/* eslint import/prefer-default-export:off */
export const bodyClass = 'cdm-author-bio';
export const bodyClassPrefix = 'cdm-author-';
export const titleRelated = 'More from ';
export const btnLabel = 'SEE MORE';
export const titleExpertise = 'Expertise';
export const titleEducation = 'Education';
